
















































import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { DxEditing, DxColumn, DxFilterRow, DxStateStoring, DxColumnFixing } from 'devextreme-vue/data-grid';
import DevExpress from 'devextreme/bundles/dx.all';
import CustomStore from 'devextreme/data/custom_store';
import { DataGrid } from '@questelservices/common-vue';
import { CommentService } from '@/service/CommentService';
import { CommentEmailDto } from '@/models/comments/CommentEmailDto';

@Component({
  components: {    
    DataGrid,
    DxColumn,
    DxFilterRow,
    DxEditing,
    DxStateStoring,
    DxColumnFixing
  }
})
export default class EmailTable extends Vue {
    $refs: Vue['$refs'] & {
      emailDataGrid?: DataGrid;
    } = {};
    
    @Prop()
    isParsedEmail!: boolean;

    private emailStoreOptions: DevExpress.data.CustomStoreOptions;
    private commentService: CommentService = new CommentService();    
    private initialLoad: boolean = true;

    constructor() { 
      super();        

      this.emailStoreOptions = {       
        key: 'EmailId',     
        load: (loadOptions) => {          
          if(loadOptions.filter === undefined) {
            loadOptions.filter = [];
          }

          // parsed email means no errors
          loadOptions.filter.push("HasError", "=", !this.isParsedEmail);          

          if (this.initialLoad) {
            this.initialLoad = false;
            this.applyIssueResolvedFilter();
          }          
          return this.commentService.searchCommentEmail(loadOptions)
        },
        update: (key, values) => this.commentService.editCommentEmail(key, values)
      };
    }   

    private get dataGrid(): DevExpress.ui.dxDataGrid {
        return (this.$refs.emailDataGrid as any).$refs.dxDataGrid.instance;
    }

    public refreshDataGrid() {      
      if (this.$refs.emailDataGrid) {
        (this.$refs.emailDataGrid as any).refreshDataGrid();
      }
    }

    private applyIssueResolvedFilter() {
        this.dataGrid.columnOption('IssueResolved', 'filterValue', false);
    }  

    rowUpdating(e: any) {
        // Add back any data not edited
        e.newData = Object.assign({}, e.oldData, e.newData);
    }

    private attachmentListDisplay(dto: CommentEmailDto): string {
      return dto.Attachments.join(', ');      
    }    
}
